import React from "react"
import { useTranslation } from "react-i18next"
import { Button, Box, FormControl, useTheme, makeStyles, TextField } from "@material-ui/core"
import "./Reset.css"

const useStyles = makeStyles((theme) => ({
	"& .MuiBox-root": {
		margin: 0,
	},
	formControl: {
		...theme.typography.body1,
	},
}))

const Reset = ({ handleReset, canApplyFilter = false }) => {
	const theme = useTheme()
	const classes = useStyles()
	const [t] = useTranslation("global")
	return (
		<>
			<Box style={{ maxWidth: 43, minWidth: 43 }} m={1}>
				<FormControl
					style={{ cursor: !canApplyFilter ? "not-allowed" : "pointer" }}
					fullWidth
					size="small"
					variant="outlined"
					color={theme?.palette?.grey?.[300]}
					className={classes.formControl}
				>
					<Button
						variant="text"
						size="small"
						style={{ padding: "10px 20px", color: theme?.palette?.grey?.[700] }}
						disabled={!canApplyFilter}
						onClick={handleReset}
					>
						{t("filterConceptDropdown.reset")}
					</Button>
				</FormControl>
			</Box>
		</>
	)
}

export default Reset
